import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../data/services/api.service';
import { apiColletions } from '../core/constant/api-collection';
import { LoaderService } from '../data/services/loader.service';

export class Language {
  code!: string;
  label!: string;
  shorthand!: string;
  langJson!: any;
  userVisibility!: boolean;
}

@Injectable({ providedIn: 'root' })
export class LangService {
  supportedLanguages: Language[] = [];
  IMAGE_URL = environment.IMAGE_URL;
  defaultLanguage: any = localStorage.getItem('theme_lang') ?? environment.defaultLang;

  private languages = new BehaviorSubject<any>(null);
  languagesObservable = this.languages.asObservable();


  constructor(private translate: TranslateService , private _api : ApiService , private loader : LoaderService) {}

  getLanguageList(parameters:any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      this._api.get({ url: apiColletions.getLanguageList, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  set language(lang: string) {
    let language = lang || '';

    const isSupportedLanguage = this.supportedLanguages
      .map((item) => item.code)
      .includes(language);
    if (!isSupportedLanguage) {
      language = this.defaultLanguage;
    }
    this.translate.use(language);
    localStorage.setItem('theme_lang', lang);
  }

  get languageShorthand(): string {
    let currentLang = this.supportedLanguages.find(
      (item) => item.code === this.translate.currentLang
    );
    return currentLang ? currentLang.shorthand : 'en';
  }

  get languageLabel(): string {
    let language = this.supportedLanguages.find(
      (item) => item.code === this.translate.currentLang
    );
    return language?.label || '';
  }

  get languageIndex(){
    let languageIndex = this.supportedLanguages.findIndex((item) => item.code == this.translate.currentLang);

    return languageIndex;
  }
}
